<template>
  <el-rate
    v-model="modelValue"
    :max="max"
    @change="onChange"/>
</template>

<script>
export default {
    name : 'TicketFormRate',

    props : ['value', 'item'],

    data() {
      return {
        max : 5,
        modelValue : null
      }
    },

    watch : {
      value() {
        // console.log('#23 watch', this.value, this.modelValue);

        this.modelValue = Number(this.value);
      }
    },

    mounted() {
      // console.log('#29 mounted', this.value, this.modelValue);

      this.modelValue = Number(this.value);

      this.handleEnums();
    },

    methods : {
      handleEnums() {
        if ( !this.item || !this.item.enums ) {
          console.log('#38 TicketFormRate handleEnums no enums', this.item);
          return;
        }

        for (let i = 0; i < this.item.enums.length; i++) {
          if ( 'max' == this.item.enums[i].id ) {
            this.max = Number(this.item.enums[i].name);
          }
        }
      },

      onChange() {
        this.$emit('input', this.modelValue);

        this.$emit('change', this.modelValue);
      }
    }
}
</script>

<style>
  .ticket_form_slider {
    padding-left: 8px;
  }

  .ticket_form_slider .el-input-number {
    line-height: 30px;
    width: 130px;
  }

  .ticket_form_slider .el-input__inner {
    text-align: center!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormRate.vue